import axios from "axios";
import Joi from 'joi-browser';
import { APIAddress } from "constants/config";

export const CONTENT_TYPE = ['text', 'picture', 'video', 'pictureAndText', 'videoAndText']

export const schema = Joi.object().keys({
	index: Joi.number().integer().allow(''),
	content_type: Joi.string().valid(CONTENT_TYPE).allow(''),
	text: Joi.string().allow(''),
  image_url: Joi.string().allow(''),
  video_url: Joi.string().allow(''),
  custom_data: Joi.object().allow('').allow(null),
});

export default function updateContent(contentId, contentInfo) {

  if(!contentId){
    return new Promise((resolve, reject) => {
      reject({
        error: new Error('Missing content ID')
      })
    })
  }

  let validateResult = Joi.validate(contentInfo, schema);

  if (validateResult.error) {
    return new Promise((resolve, reject)=> {
      reject(validateResult);
    });
  }

	let toServer = {};
	if(contentInfo.content_type){
		toServer = {
			...contentInfo,
			content_type: CONTENT_TYPE.indexOf(contentInfo.content_type)
		}
	} else {
		toServer = {...contentInfo}
	}

  return new Promise((resolve, reject) => {
    axios.put(APIAddress, {'uri': `/u_content/${contentId}/`,
    'method': 'PUT',
    'data': JSON.stringify(toServer),
    'token': localStorage.getItem('token')})
    .then((res) => {
      resolve(res.data);
    })
    .catch((err) => {
      reject(err);
    })
  })
}



// WEBPACK FOOTER //
// ./src/controllers/controllers/poster/updateContent.js